var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8 8C14.8 11.7555 11.7555 14.8 8 14.8C4.24446 14.8 1.2 11.7555 1.2 8C1.2 4.24446 4.24446 1.2 8 1.2C11.7555 1.2 14.8 4.24446 14.8 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM4.91716 4.91716C5.07337 4.76095 5.32663 4.76095 5.48284 4.91716L8.00023 7.43454L10.5174 4.91735C10.6736 4.76114 10.9269 4.76114 11.0831 4.91735C11.2393 5.07356 11.2393 5.32682 11.0831 5.48303L8.56591 8.00022L11.0829 10.5172C11.2391 10.6734 11.2391 10.9267 11.0829 11.0829C10.9267 11.2391 10.6734 11.2391 10.5172 11.0829L8.00023 8.56591L5.48303 11.0831C5.32683 11.2393 5.07356 11.2393 4.91735 11.0831C4.76114 10.9269 4.76114 10.6736 4.91735 10.5174L7.43454 8.00023L4.91716 5.48284C4.76095 5.32663 4.76095 5.07337 4.91716 4.91716Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveBlack);
export default __webpack_public_path__ + "static/media/RemoveBlack.a8934846bd5432963cdee0234fbaa343.svg";
export { ForwardRef as ReactComponent };